import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as classes from "../../scss/load-spinner.scss";
export class LoaderSpinner extends React.Component {
    render() {
        return (_jsx("div", { style: { position: "absolute", left: 0, right: 0, marginLeft: "auto", zIndex: Number.MAX_SAFE_INTEGER, marginRight: "auto" }, children: _jsx("div", { className: classes.loadSpinnerComponentScope, children: _jsx("div", { className: "loader" }) }) }));
    }
}
//# sourceMappingURL=LoaderSpinner.js.map